// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

/* Prevent horizontal scrolling across the entire app */
html, body {
  overflow-x: hidden;  /* Hide horizontal scrolling */
  /* width: 100vw; */
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":";;AAEA,uDAAuD;AACvD;EACE,kBAAkB,GAAG,8BAA8B;EACnD,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB","sourcesContent":["\n\n/* Prevent horizontal scrolling across the entire app */\nhtml, body {\n  overflow-x: hidden;  /* Hide horizontal scrolling */\n  /* width: 100vw; */\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
